var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwarding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.828125,
    y: 0.862183,
    width: 95.2396,
    height: 95.2396,
    rx: 20.3547,
    fill: "#5E1B0C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1106_10971)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.9199,
    y: 55.7617,
    width: 54.6157,
    height: 22.2492,
    rx: 3.71536,
    fill: "#F8F7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8145 35.1145L42.8846 35.1145",
    stroke: "#FE6533",
    strokeWidth: 7.43071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1002 32.3326L55.7175 21.9345C53.3778 19.5913 49.373 21.2484 49.373 24.5597V45.5507C49.373 48.8787 53.4122 50.5281 55.7417 48.1514L66.1245 37.5586C67.5499 36.1043 67.5391 33.7736 66.1002 32.3326Z",
    fill: "#F8F7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3209 32.3326L46.9382 21.9345C44.5985 19.5913 40.5938 21.2484 40.5938 24.5597V45.5507C40.5938 48.8787 44.6329 50.5281 46.9624 48.1514L57.3452 37.5586C58.7706 36.1043 58.7598 33.7736 57.3209 32.3326Z",
    fill: "#FE6533"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1106_10971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.4457,
    height: 59.4457,
    fill: "white",
    transform: "translate(18.6621 18.6963)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwarding);
export default __webpack_public_path__ + "static/media/Forwarding.57d7e151b114545520dce6095bf3f360.svg";
export { ForwardRef as ReactComponent };